export default {"src":"/_next/static/media/features-my-crate.0c6a8904.gif","height":540,"width":800};